if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.webDrawBtn = this.querySelector('.web-drawer-btn');

        this.dateUtils = new DateUtils();
        this.productUtils = new ProductUtils(this.dataset.handle)
        this.deviceWidth = new DeviceWidth()
      }

      connectedCallback() {
        this.addToRecentlyViewed();
        this.checkIfComingSoon();
        this.checkIfReleaseSoon()
        this.handleAccordions();
        this.handleScroll();
      }

      handleScroll() {
        if (!this.deviceWidth.isDesktop) return

        this.stickyHeader = this.querySelector('[data-sticky-header]');
        this.stickyButton = this.querySelector('[data-sticky-button]');

        this.setValue("--sticky-header-top", this.stickyHeader.getBoundingClientRect().top);
        this.setValue("--sticky-button-top", this.stickyButton.getBoundingClientRect().top);

        this.lastScroll = -9999;

        this.querySelector('form').addEventListener('submit', (e) => {
          e.preventDefault();

          const checked = this.querySelector('variant-radios').querySelector('input[type="radio"]:checked');
          if (checked) {
            this.querySelector('form').requestSubmit();
            return;
          }

          const variantPickerContainer = this.querySelector('#desktop-variant-picker');
          const top = variantPickerContainer.getBoundingClientRect().top + window.scrollY - this.getValue("--sticky-header-top") - 36;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });

        });
        
        window.addEventListener('scroll', () => {
          const isScrollDown = window.scrollY > this.lastScroll;
          const isScrollTop = !isScrollDown;

          this.lastScroll = window.scrollY;
          const trackerTopVisible = this.isElementVisible(this.querySelector('[data-tracker-top]'));

          const scrollDownTrackerNotVisible = isScrollDown && !this.isElementVisible(this.querySelector('[data-tracker-bottom]'));
          const scrollUpTrackerNotVisible = isScrollTop && !trackerTopVisible;
          
          let value = parseInt(this.getValue("--sticky-top")) || 14;

          this.stickyHeader.style.marginBottom = this.isSticky(this.stickyHeader) ? '3rem' : '0px';
          if (scrollDownTrackerNotVisible) {
            value = value - 10;
          } 
          else if (scrollUpTrackerNotVisible) {
            value = value + 10;
          }  else if (isScrollTop && trackerTopVisible) {
            value = 14;  
          }

          
          this.setValue("--sticky-top", value);
        });
      }

      isSticky(element) {
        const rect = element.getBoundingClientRect();
        const computedTop = parseFloat(getComputedStyle(element).top) || 0;
        return rect.top <= computedTop;
      }

      getValue(property) {
        return getComputedStyle(this).getPropertyValue(property).trim().replace('px','');
      }

      setValue(property, value) {
        this.style.setProperty(property, value + 'px');
      } 

      isElementVisible = (ele) => {
        const rect = ele.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      };

      async checkIfReleaseSoon() {
        const comingSoonDate = this.getAttribute('data-coming-soon-date');
        if (comingSoonDate) return
        const releaseSoon = this.getAttribute('data-release-coming-soon');
        if (!releaseSoon) return
        const productAvailable = await this.productUtils.checkIfProductAvailable();
        if (productAvailable) return
        this.handleHideEls()
        this.webDrawBtn.innerHTML = 'Releasing Soon'
      }

      handleAccordions() {
        const accordions = Array.from(this.querySelectorAll('#main-product-grid .product__accordion details ') || [])
        accordions.forEach(el => {
          el.addEventListener('click', () => {
            accordions.forEach(subEl => {
              if (subEl.getAttribute('id') !== el.getAttribute('id')) {
                subEl.removeAttribute('open')
              }
            })
          })
        })
      }

      showSizes() {
        this.querySelector('.pdp-details').classList.remove('hide');
        this.querySelector('#desktop-variant-picker').classList.remove('hide');
        this.querySelector('#mobile-variant-picker').classList.remove('hide');

        this.webDrawBtn.classList.add('hide');
      }

      async checkIfComingSoon() {
        const comingSoonDate = this.getAttribute('data-coming-soon-date');
        if (!comingSoonDate) return

        const currentDate = this.dateUtils.getCurrentUTCDate();
        const countDownDate = this.dateUtils.formatDate(comingSoonDate);
        const differenceMs = countDownDate - currentDate;

        this.webDrawBtn = this.querySelector('.web-drawer-btn');

        if (Math.sign(differenceMs) === -1) {
          await this.handleCountdownEnded();
          return;
        }

        this.handleHideEls()
        this.changeWebDrawCounter(countDownDate);

        setInterval(() => {
          this.changeWebDrawCounter(countDownDate);
        }, 1000);
      }

      async handleCountdownEnded() {
        const productAvailable = await this.productUtils.checkIfProductAvailable();
        if (productAvailable) {
          this.showSizes();
          return
        }

        this.webDrawBtn.innerHTML = window.productForm.webDrawAvailableFewSeconds
        this.handleHideEls()
        setInterval(async () => {
          const isAvailable = await this.productUtils.checkIfProductAvailable();
          if (isAvailable) {
            window.location.reload();
          }
        }, 5000);
      }


      handleHideEls() {
        this.webDrawBtn.classList.remove('hide');
        this.querySelector('.desktop-wishlist-btn').classList.add('hide')
        this.querySelector('.pdp-details').classList.remove('hide');
      }

      changeWebDrawCounter(countDownDate) {
        this.querySelectorAll('.web_draw_message')?.forEach((el) => el.classList.remove('twcss-hidden'));
        const currentDate = this.dateUtils.getCurrentUTCDate();
        const differenceMs = parseInt(countDownDate - currentDate);

        if (Math.sign(differenceMs) === -1) {

          this.webDrawBtn.innerHTML = window.productForm.webDrawAvailableFewSeconds;
          window.location.reload()
          return
        }

        const timeObj = this.dateUtils.getTimeObjFromMS(differenceMs);
        const times = this.dateUtils.getTimeString(timeObj);

        this.webDrawBtn.innerHTML = `${window.productForm.webDrawAvailable}  <span class='countdown-time'>( ${times} )</span> `;
      }

      addToRecentlyViewed() {
        const recentlyViewed = JSON.parse(localStorage.getItem('RecentlyViewedSJ')) || [];
        const handle = this.getAttribute('data-url').replace('/products/', '');

        if (!recentlyViewed.find((string) => string === handle)) {
          recentlyViewed.push(handle);
        }

        localStorage.setItem('RecentlyViewedSJ', JSON.stringify(recentlyViewed));
      }

      disconnectedCallback() {}
    }
  );
}


if (!customElements.get('pdp-thumbnails')) {
  customElements.define(
    'pdp-thumbnails',
    class PDPThumbnails extends HTMLElement {
      constructor() {
        super();
        this.handleSmoothScrolling();
        this.mediaSelector = this.dataset.type === 'product-modal' ? '.zoom-image' : '.product__media';

        this.scrollableElement = window;
        if (this.dataset.type === 'product-modal') {
          this.scrollableElement = document.querySelector('product-modal');
        }

        this.scrollableElement.addEventListener('scroll', () => {
          this.handleOnScroll();
        });
      }

      getThumbnails() {
        return this.querySelectorAll('.thumbnail');
      }

      handleOnScroll() {


        const productMediaElements = document.querySelectorAll(this.mediaSelector);
        const thumbnails = this.getThumbnails();
        if (!thumbnails.length) return;
        productMediaElements.forEach((o, index) => {
          if (o.getBoundingClientRect().top<=window.innerHeight/2&&o.getBoundingClientRect().top+o.offsetHeight>window.innerHeight/2) {
            thumbnails[index]?.setAttribute('aria-current', true);
          } else {
            thumbnails[index]?.removeAttribute('aria-current');
          }
        });
      }

      handleSmoothScrolling() {
        this.getThumbnails().forEach((element) => {
          element.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = element.getAttribute('href');
            const scrollableElement = this.dataset.type === 'product-modal' ? this.scrollableElement : document;

            scrollableElement.querySelector(targetId).scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });
          });
        });
      }
    }
  );
}